(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-bdy-section]').forEach(section => {
      if (section.dataset.bdyReady) return;
      section.dataset.bdyReady = 'true';
      if (section.dataset.bdySection === 'video_banner') {
        const desktop = section.querySelector('.vbn__desktop');
        const mobile = section.querySelector('.vbn__mobile');
        const media = window.matchMedia('(max-width:750px)');
        let current;
        function select() {
          current = media.matches ? mobile : desktop;
          [desktop, mobile].forEach(video => { if (video !== current) video.pause(); });
          if (!current) return;
          const source = current.querySelector('source');
          if (!source.src) { source.src = source.dataset.src; current.load(); }
          current.muted = true;
          current.play().catch(() => {});
        }
        media.addEventListener('change',select); select();
      }
      if (section.dataset.bdySection === 'shop_by_collection') {
        const scroller=section.querySelector('.sbc__scroller'), prev=section.querySelector('[data-dir="prev"]'), next=section.querySelector('[data-dir="next"]');
        const update=()=>{prev.disabled=scroller.scrollLeft<=4;next.disabled=scroller.scrollLeft+scroller.clientWidth>=scroller.scrollWidth-4;};
        [prev,next].forEach(button=>button.addEventListener('click',()=>scroller.scrollBy({left:(button===next?1:-1)*(scroller.querySelector('.sbc__tile').offsetWidth+14),behavior:reducedMotion.matches?'auto':'smooth'})));
        scroller.addEventListener('scroll',update);new ResizeObserver(update).observe(scroller); update();
      }
      if (section.dataset.bdySection === 'press_quotes') {
        const quotes=[...section.querySelectorAll('.prq__q')],logos=[...section.querySelectorAll('.prq__logo')];
        let current=0,timer;
        const show=i=>{current=i;quotes.forEach((q,n)=>{q.classList.toggle('is-active',n===i);q.setAttribute('aria-hidden',String(n!==i));});logos.forEach((l,n)=>{l.classList.toggle('is-active',n===i);l.setAttribute('aria-pressed',String(n===i));});};
        const stop=()=>clearInterval(timer),start=()=>{stop();if(!reducedMotion.matches)timer=setInterval(()=>show((current+1)%quotes.length),6500);};
        logos.forEach((logo,i)=>logo.addEventListener('click',()=>{stop();show(i);}));
        section.addEventListener('mouseenter',stop);section.addEventListener('mouseleave',start);section.addEventListener('focusin',stop);show(0);start();
        document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(section))stop();},{once:true});
      }
      if (section.dataset.bdySection === 'products') {
        section.querySelectorAll('.bsr__tile').forEach(tile=>{
          const swatches=[...tile.querySelectorAll('.bsr__swatch')],form=tile.querySelector('form'),button=form.querySelector('button'),input=form.querySelector('[name="id"]');
          swatches.forEach(swatch=>swatch.addEventListener('click',()=>{
            input.value=swatch.dataset.id;
            swatches.forEach(item=>{item.classList.toggle('is-active',item===swatch);item.setAttribute('aria-pressed',String(item===swatch));});
            tile.querySelector('[data-current-shade]').textContent=swatch.dataset.shade.split(' (')[0].replace('Original – ','');
            if(swatch.dataset.image){const image=tile.querySelector('.bsr__img[data-role="default"]')||tile.querySelector('.bsr__img');image.src=swatch.dataset.image;image.removeAttribute('srcset');}
            tile.querySelector('.bsr__stage').href=tile.querySelector('.bsr__stage').href.split('?')[0]+'?variant='+swatch.dataset.id;
            button.disabled=swatch.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to cart — '+swatch.dataset.price;
            form.querySelector('[role="status"]').textContent='';
          }));
          form.addEventListener('submit',async event=>{
            event.preventDefault();
            if (form.dataset.adding === 'true') return;
            form.dataset.adding='true';
            const label=button.textContent;
            button.disabled=true;button.textContent='Adding…';
            swatches.forEach(swatch=>swatch.disabled=true);
            const feedback=form.querySelector('[role="status"]');
            feedback.textContent='';
            try {
              const sections=[];
              document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections}}));
              const data=new FormData(form);
              data.append('sections',sections.join(','));
              data.append('sections_url',window.location.pathname);
              const root=window.Shopify?.routes?.root||'/';
              const response=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
              const result=await response.json();
              if(!response.ok || result.status) throw new Error(result.description||'Could not add this item.');
              feedback.textContent='Added to cart';
              const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
              if(!cartResponse.ok) throw new Error('Item added. Open the cart to view it.');
              const cart=await cartResponse.json();
              cart.sections=result.sections;
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:data.get('id'),cart});
              document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:result}}));
              document.querySelector('cart-drawer')?.show(button);
            }
            catch(error){feedback.textContent=error.message;}
            finally {
              delete form.dataset.adding;
              button.disabled=false;button.textContent=label;
              swatches.forEach(swatch=>swatch.disabled=false);
            }
          });
        });
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
